import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from "@mui/icons-material/Search";

import { visuallyHidden } from '@mui/utils';
import {
    InspectionContents,
    CautionButton,
    NomalButton
} from '../../css/CSS.js';
import LoadingDialog from '../../Loading';
import useAuthAxios from "../../../useAuthAxios";
import PropTypes from 'prop-types';
import InspectionBreadcrumbs from '../InspectionBreadcrumbs.js';
import Stack from '@mui/material/Stack';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import { toHalfWidthAlpha, toHalfWidthKana, toHalfWidthNumber } from '../InspectionValidations'
import InspectionCommonDialog from '../InspectionCommonDialog'

export default function CustomerListBody() {
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") };


    const TableFlame = styled(TableContainer)({
        borderRadius: "10px 10px 0 0",
    });

    const Header = styled(TableRow)({
        backgroundColor: "#289bdf",
    });
    const Text = styled(Typography)({
        color: "#FFFFFF",
        transform: "scale(0.9)",
    });

    let deleteAuth = false;

    if (localStorage.getItem("inspectionRecordDelete") === "1") {
        deleteAuth = true;
    }

    const { control, handleSubmit, getValues, setValue } = useForm({
        defaultValues: {
            kojiCD: "",
            customerCD: "",
            shitenCD: "",
            thokiYuryoFlg: "",
            customerNameKana: ""
        },
        mode: "onBlur",
        reValidateMode: "onBlur",
    });


    const navigate = useNavigate();

    const [deleteMode, setDeleteMode] = useState(false);
    const [processing_search, setProcessing_search] = useState(false);
    const [processing_searchReset, setProcessing_searchReset] = useState(false);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [list, setList] = useState();
    const [kojiCD, setKojiCD] = useState('');
    const [rptShubetsuName, setRptShubetsuName] = useState('');
    const [delDialog, setDelDialog] = useState(false);
    const [officeList, setOfficeList] = useState([]);
    const [shitenSelectList, setShitenSelectList] = useState([]);
    const authAxios = useAuthAxios();
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                sort: {
                    order: isAsc ? 'desc' : 'asc',
                    orderBy: property,
                }
            }
            sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(newCondition));
        }
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function stableSort(array, comparator) {
        const stabilizedThis = array?.map((el, index) => [el, index]);
        stabilizedThis?.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis?.map((el) => el[0]);
    }

    const handleChangePage = (event, newPage) => {
        const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                pagination: {
                    ...searchConditions.pagination,
                    page: newPage,
                }
            }
            sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(newCondition));
        }
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                pagination: {
                    page: 0,
                    pageSize: newPageSize
                }
            }
            sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(newCondition));
        }
        setRowsPerPage(newPageSize);
        setPage(0);
    };

    let headCells = [];
    headCells = [
        {
            id: 'customerNo',
            label: 'お客様No',
            align: 'left',
            width: '11%',
        },
        {
            id: 'kojiCD',
            label: '工事コード',
            align: 'left',
            width: '11%',
        },
        {
            id: 'shitenName',
            label: '支店名',
            align: 'left',
            width: '11%',
        },

        {
            id: 'yashikiName',
            label: '邸名',
            align: 'left',
            width: '32%',
        },
        {
            id: 'totalReportNum',
            label: '総件数',
            align: 'left',
            width: '11%',
        },
        {
            id: 'activeReportNum',
            label: '作成中件数',
            align: 'left',
            width: '11%',
        },
        {
            id: 'button',
            label: '',
            align: 'left',
            width: '11%',
        },
    ];


    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <Header sx={{ backgroundColor: props.mode === true ? "#C0C0C0" : "#289bdf" }}>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            width={headCell.width}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                disabled={headCell.id === 'button'}
                            >
                                <Text sx={{ color: props.mode === true ? "#000000" : "#FFFFFF" }}>{headCell.label}</Text>
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </Header>
            </TableHead >
        );
    }

    EnhancedTableHead.propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number,
    };

    const [processing, setProcessing] = useState(false);
    const disable_processing = useRef(false);


    React.useLayoutEffect(() => {
        setProcessing(true)
        authAxios
            .get('api/inspection/inspectionVendor/offices', { headers })
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    const selectList = [];
                    setOfficeList(listdata);
                    selectList.push({ shitenCD: "", shitenName: "未選択" })
                    listdata.shitenInfo.forEach((e) => selectList.push({ shitenCD: e.shitenCD, shitenName: e.shitenName }))
                    setShitenSelectList(selectList)
                    setProcessing(false);
                }
            }).catch((response) => {
                alert("支店情報取得に失敗しました。", response.body);
                setProcessing(false)
                navigate("/inspection");
            });
        setProcessing(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const validationRules = {
        kojiCD: {
            maxLength: {
                value: 5,
            },
            pattern: {
                value: /^[0-9a-zA-Z]+$/,
                message: "半角英数字のみ入力可能です",
            },
        },
        customerCD: {
            maxLength: {
                value: 7,
            },
            pattern: {
                value: /^[0-9a-zA-Z]+$/,
                message: "半角英数字のみ入力可能です",
            },
        },
        customerNameKana: {
            pattern: {
                value: /^[\uFF65-\uFF9F\sA-Za-z0-9]*$/,
                message: "半角英数カナで入力してください",
            },
        }
    }

    React.useEffect(() => {
        //初期表示時
        if (shitenSelectList.length === 0) return;
        //支店リストセット完了後
        const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            setValue("customerCD", searchConditions.customerCD);
            setValue("kojiCD", searchConditions.kojiCD);
            setValue("shitenCD", searchConditions.shitenCD);
            setValue("customerNameKana", searchConditions.customerNameKana);
            setRowsPerPage(searchConditions.pagination.pageSize);
            setPage(searchConditions.pagination.page);
            setOrder(searchConditions.sort.order);
            setOrderBy(searchConditions.sort.orderBy);
            setProcessing(true)
            authAxios
                .get('api/visitReport/customers?kojiCD=' + getValues("kojiCD") + '&customerCD=' + getValues("customerCD") + '&shitenCD=' + getValues("shitenCD"))
                .then((response) => {
                    if (response.status === 200) {
                        const listdata = JSON.parse((JSON.stringify(response.data)));
                        setList(listdata);
                        setProcessing(false);
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        alert("認証情報が正しくありません。");
                        switch (localStorage.getItem("loginType")) {
                            case "0":
                                navigate("/");
                                break
                            case "1":
                                navigate("/omsuser");
                                break
                            case "2":
                                navigate("/vender");
                                break
                            default:
                                navigate("/");
                        }
                    } else {
                        alert("訪問記録　お客様情報の取得に失敗しました。");
                    }
                    setProcessing(false);
                });
        } else {
            if (localStorage.getItem("UserShitenCD")) {
                const defaultShitenCD = localStorage.getItem("UserShitenCD");
                const target = shitenSelectList.find(item => item.shitenCD === defaultShitenCD);
                setValue("shitenCD", target ? target.shitenCD : "");
            }
        }
    }, [shitenSelectList])

    const onSubmit = (data, e) => {
        const action = e?.nativeEvent.submitter?.value;
        switch (action) {
            case 'search':
                onSubmit_Search(data);
                break;
            default:
                return null;
        }
    }
    const fieldLabels = {
        kojiCD: "工事コード",
        customerCD: "お客様No",
        customerNameKana: "邸名（半角カナ）",
    };

    const fieldToLabel = (field) => fieldLabels[field] ?? field;
    const [dialogState, setDialogState] = useState({ open: false });
    const onError = (errors) => {
        const firstErrorKey = Object.keys(errors)[0];
        const firstError = errors[firstErrorKey];
        const message = firstError?.message;
        const fieldLabel = fieldToLabel(firstErrorKey)
        setDialogState({
            open: true,
            title: "入力エラー",
            message: fieldLabel + "は" + message,
            confirmClick: () => { setDialogState(prev => ({ ...prev, open: false })); },
            cancelClick: () => { setDialogState(prev => ({ ...prev, open: false })); },
            confirmIcon: <></>,
            buttonType: "NomalButton",
            hideCancel: true,
        })
    };
    const onSubmit_Search = (data) => {
        setProcessing_search(true);
        const apiUrl = createSearchUrl(data);
        authAxios
            .get(apiUrl)
            .then((response) => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    setList(listdata);
                    setPage(0);
                    setOrder('asc');
                    setOrderBy('');
                    const visitReportSearchCondition = {
                        kojiCD: data.kojiCD,
                        customerCD: data.customerCD,
                        shitenCD: data.shitenCD,
                        thokiYuryoFlg: data.thokiYuryoFlg,
                        customerNameKana: data.customerNameKana,
                        pagination: {
                            page: 0,
                            pageSize: rowsPerPage
                        },
                        sort: {
                            order: 'asc',
                            orderBy: '',
                        }
                    }
                    sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(visitReportSearchCondition));
                    setProcessing_search(false);
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    alert("認証情報が正しくありません。");
                    switch (localStorage.getItem("loginType")) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/omsuser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                } else {
                    alert("訪問記録　お客様情報の取得に失敗しました。");
                }
                setProcessing_search(false);
            });
        setTimeout(() => {
            setProcessing_search(false);
        }, 10000);
    };
    const createSearchUrl = (data) => {
        let returnUrl = 'api/visitReport/customers?kojiCD=' + data.kojiCD + '&customerCD=' + data.customerCD + '&shitenCD=' + data.shitenCD
        if (data.thokiYuryoFlg === "included") {
            returnUrl += '&thokiYuryou=1';
        } else if (data.thokiYuryoFlg === "excluded") {
            returnUrl += '&thokiYuryou=0';
        }
        return returnUrl += '&customerNameKana=' + data.customerNameKana
    }

    const onSubmit_Reset = () => {
        setProcessing_searchReset(true);
        setValue("customerCD", "", { shouldValidate: true });
        setValue("kojiCD", "", { shouldValidate: true });
        setValue("shitenCD", "", { shouldValidate: true });
        setValue("thokiYuryoFlg", "", { shouldValidate: true });
        setValue("customerNameKana", "", { shouldValidate: true });
        setOrder('asc');
        setOrderBy('');
        setList({});
        sessionStorage.removeItem('visitReportSearchCondition');
        setProcessing_searchReset(false);
    }

    const onSubmit_houmon = (customerCD, kojiCD, shiten, teimei, canEdit, canFix, thokiYuryoFlg) => {
        if (deleteMode) { return; }
        if (disable_processing.current === true) { return; }
        disable_processing.current = true;
        setProcessing(true);
        authAxios
            .get('api/visitReport/visitReports/' + "?kojiCD=" + kojiCD + "&customerCD=" + customerCD)
            .then(response => {
                if (response.status === 200) {
                    const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
                    if (previousCondition) {
                        const searchConditions = JSON.parse(previousCondition);
                        const newCondition = {
                            ...searchConditions,
                            reportSort: {
                                order: 'asc',
                                orderBy: '',
                            },
                            reportPagination: {
                                page: 0,
                                pageSize: 10
                            }
                        }
                        sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(newCondition));
                    }
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    navigate("/inspection/visitReport/customerlist/reportlist", { state: { listdata: listdata, shiten: shiten, koji: kojiCD, teimei: teimei, customer: customerCD, canEdit: canEdit === 1, canFix: canFix === 1, thokiYuryoFlg: thokiYuryoFlg } });

                    disable_processing.current = false
                }
            }).catch((response) => {
                alert("訪問記録の取得に失敗しました。", response.body);
                setProcessing(false);
                disable_processing.current = false
            })
    }



    const cancelClick = () => {
        setDelDialog(false);
    }


    return (
        <InspectionContents style={{ marginLeft: 0, marginRight: 0 }} maxWidth="xl">
            <InspectionBreadcrumbs />
            <InspectionCommonDialog open={dialogState?.open} dialogState={dialogState} setDialogState={setDialogState} />
            <Typography variant='h5' sx={{ mb: 1 }}>
                条件を指定して検索ボタンを押してください。何も条件を指定しないと全件検索になります。
            </Typography>
            <form onSubmit={handleSubmit(onSubmit, onError)} >
                <LoadingDialog load={processing || processing_search || processing_searchReset} />
                <Grid container spacing={2}>
                    <Grid container item rowSpacing={2} xs={10}>
                        <Grid container item xs={12} >
                            <Grid item xs="auto">
                                <SearchIcon />
                                <Controller
                                    control={control}
                                    name="customerCD"
                                    rules={validationRules.customerCD}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            id="customerCD"
                                            label="お客様No"
                                            variant="standard"
                                            error={fieldState.invalid}
                                            helperText={fieldState.error?.message}
                                            inputProps={{ maxLength: 7 }}
                                            sx={{
                                                width: 90,
                                                "& .MuiFormHelperText-root": {
                                                    fontSize: "16px"
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs="auto" >
                                <SearchIcon />
                                <Controller
                                    control={control}
                                    name="kojiCD"
                                    rules={validationRules.kojiCD}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            id="kojiCD"
                                            label="工事コード"
                                            variant="standard"
                                            error={fieldState.invalid}
                                            helperText={fieldState.error?.message}
                                            inputProps={{ maxLength: 5 }}
                                            sx={{
                                                width: 80,
                                                "& .MuiFormHelperText-root": {
                                                    fontSize: "16px"
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs="auto" >
                                <SearchIcon />
                                <Controller
                                    control={control}
                                    name="shitenCD"
                                    render={({ field, fieldState }) => (
                                        <FormControl error={fieldState.invalid} >
                                            <InputLabel id="area-label">支店</InputLabel>
                                            <Select
                                                labelId="shiten-label"
                                                label="支店"
                                                variant="standard"
                                                sx={{ width: 150 }}
                                                {...field}
                                            >
                                                {shitenSelectList.map((row, index) => {
                                                    return (
                                                        <MenuItem key={index} value={row.shitenCD}>{row.shitenName}</MenuItem>
                                                    );
                                                })}
                                            </Select>
                                            <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item xs={8} >
                            <SearchIcon />
                            <Grid item xs>
                                <Controller
                                    control={control}
                                    name="customerNameKana"
                                    rules={validationRules.customerNameKana}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            id="customerNameKana"
                                            label="邸名（半角カナ）"
                                            variant="standard"
                                            fullWidth
                                            inputProps={{ maxLength: 40 }}
                                            error={fieldState.invalid}
                                            helperText={fieldState.error?.message}
                                            sx={{
                                                "& .MuiFormHelperText-root": {
                                                    fontSize: "16px"
                                                }
                                            }}
                                            onBlur={(e) => {
                                                let converted = toHalfWidthKana(e.target.value);
                                                converted = toHalfWidthAlpha(converted);
                                                converted = toHalfWidthNumber(converted);
                                                if (converted !== e.target.value) {
                                                    field.onChange(converted);
                                                }
                                                field.onBlur();
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    let converted = toHalfWidthKana(e.target.value);
                                                    converted = toHalfWidthAlpha(converted);
                                                    converted = toHalfWidthNumber(converted);

                                                    if (converted !== e.target.value) {
                                                        field.onChange(converted);
                                                    }
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container item xs={2} display="flex" justifyContent="center" alignItems="center">
                        <Stack spacing={1} sx={{ width: '100%' }}>
                            <NomalButton
                                className="confButton"
                                type="submit"
                                value="search"
                                disabled={processing_search}
                            ><SearchIcon sx={{ mr: 1 }} />
                                {processing_search ? "検索中" : "検索"}
                            </NomalButton>
                            <CautionButton
                                type="button"

                                disabled={processing_searchReset}
                                onClick={() => onSubmit_Reset()}
                            ><RefreshIcon sx={{ mr: 1 }} />
                                {processing_searchReset ? "リセット中" : "検索条件リセット"}
                            </CautionButton>
                        </Stack>
                    </Grid>
                </Grid>
            </form>
            <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ mt: 1, mr: 5 }}
            >
                <HomeWorkIcon color="success" />
                <Typography variant='h7' color="text.secondary">
                    ：長期優良住宅
                </Typography>
            </Box>
            <TableFlame sx={{ mt: 1 }}>
                <Table
                    align="center"
                >
                    <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={list?.length}
                        mode={deleteMode}
                    />
                    <TableBody>
                        {
                            stableSort(list?.customerInfoList, getComparator(order, orderBy))
                                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                ?.map((row, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            hover
                                            tabIndex={-1}>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.customerNo}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.kojiCD}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.shitenName}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                    {row.thokiYuryoFlg === 1 ?
                                                        <HomeWorkIcon color="success" />
                                                        :
                                                        <Box sx={{ width: 24, height: 24 }} />}
                                                    {row.yashikiName}
                                                </Box>
                                            </TableCell>
                                            <TableCell align="center">{row.totalReportNum}件</TableCell>
                                            <TableCell align="center">{row.activeReportNum}件</TableCell>
                                            <TableCell align="left">
                                                <NomalButton
                                                    className="confButton"
                                                    type="submit"
                                                    onClick={() => onSubmit_houmon(row.customerNo, row.kojiCD, row.shitenName, row.yashikiName, row.canEdit, row.canFix, row.thokiYuryoFlg)}
                                                    disabled={processing_search}
                                                >
                                                    {"訪問記録"}
                                                </NomalButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                        }
                    </TableBody>
                </Table>
            </TableFlame>
            {list &&
                Object.keys(list).length !== 0 ?
                <TablePagination
                    component="div"
                    count={list?.customerInfoList?.length}
                    labelRowsPerPage="表示件数"
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 30, 50]}
                    page={page}
                    labelDisplayedRows={(from, to,
                        count = list?.customerInfoList?.length) => (`全${count}件中　${from.from}件～${from.to === -1 ? from.count : from.to}件を表示  `)}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                : <Grid />
            }
        </InspectionContents >
    );
}